import RoutesMap from 'signin-app/routes/routes-map';
const GUEST_RETURN_TO_ROUTES = [RoutesMap.pin, RoutesMap.overview, RoutesMap.qr];
// Location state can hold anything, so only the screens with a Guest button are trusted as a destination.
export const guestReturnTo = (returnTo) => typeof returnTo === 'string' && GUEST_RETURN_TO_ROUTES.includes(returnTo) ? returnTo : '/';
